export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11542.7b91b032.jpg";